import Vue from 'vue'
import { getAccessToken, getRefreshToken, setAccessToken } from '@/utils/cookie'
import HeaderFilters from '@/components/tabulator/Filter'
import { accessTokenValid } from '@/router/auth'
import { EventBus } from '@/router/bus'
import router from '@/router'

export default {
  data () {
    return {
      tabulatorInstance: {},
      instancesArray: [],
      pageLoader: false,
      switchTabulatorPage: false,
      ADMIN_CLAIM: 'Claim_Admin',
      AUTHORIZATION: 'Authorization',
      REFRESH_TOKEN: 'Refresh_Token',
      justLoaded: true,
      currentFilter: [],
      filters: null,
      tabulatorOptions: {
        tooltips: true,
        tooltipsHeader: true,
        footerElement: '<div class="total-elements">' + this.$t('tabulator.totalElements') + '<span class="total-rows-number"></span></div>',
        movableColumns: true,
        columnMinWidth: 80,
        locale: this.$i18n.locale,
        pagination: 'remote',
        ajaxFiltering: true,
        ajaxLoader: false,
        ajaxSorting: true,
        resizableColumns: 'header',
        layout: 'fitColumns',
        layoutColumnsOnNewData: true,
        paginationSizeSelector: [5, 10, 25, 50],
        paginationSize: 10,
        ajaxResponse: this.ajaxResponse,
        ajaxURLGenerator: this.formatUrl,
        paginationDataSent: {
          size: 'perPage',
          page: 'page'
        },
        virtualDom: true,
        rowClick: this.rowClick,
        langs: { sr: this.$t('tabulator') },
        ajaxConfig: {
          headers: {
            'Content-type': 'application/json; charset=utf-8',
            Authorization: 'Bearer ' + getAccessToken()
          }
        },
        ajaxRequesting: () => {
          EventBus.$emit('request')
          this.pageLoader = true
        },
        ajaxError: (response) => {
          if (response.status === 401) {
            this.refreshTokenCounter = 1
            Vue.http.headers.common[this.REFRESH_TOKEN] = 'IN_PROGRESS'
            const refreshTokenUrl = Vue.$apiConfig.loginRefresh
            Vue.http.headers.common[this.AUTHORIZATION] = 'Bearer ' + getRefreshToken()
            Vue.http.get(refreshTokenUrl)
              .then(response => {
                // this.logConsole('tabulator refresh')
                setAccessToken(response.data.payload.accessToken)
                Vue.http.headers.common[this.AUTHORIZATION] = 'Bearer ' + response.data.payload.accessToken
                Vue.http.headers.common[this.REFRESH_TOKEN] = 'DONE'
                this.refreshTokenCounter = 0
                this.tabulatorInstance.setData()
              }, error => {
                this.logConsole(error)
                this.pageLoader = true
                Vue.http.headers.common[this.REFRESH_TOKEN] = 'DONE'
              })
          }
          this.pageLoader = false
        },
        rowFormatter: (row) => {
          // set mouse event listener, otherwise it will not detect middle mouse click
          const rowElement = row.getElement()
          for (let i = 1; i < rowElement.children.length - 1; i++) {
            rowElement.children[i].onmouseup = (e) => {
              if (e.button === 0 || e.button === 1) {
                this.tabulatorOptions.rowClick(e, row)
              }
            }
          }
        }
      }
    }
  },
  computed: {
    tabFiltersStorageName () {
      return `tabulatorFilters-${this.$router.currentRoute.path}`
    },
    tabSortersStorageName () {
      return `tabulatorSorters-${this.$router.currentRoute.path}`
    }
  },
  methods: {
    setInitialParameters () {
      const query = router.currentRoute.query
      const sorters = JSON.parse(localStorage.getItem(this.tabSortersStorageName))
      if (sorters && sorters.perPage) {
        this.tabulatorOptions.paginationSize = sorters.perPage
      }
      if (sorters && sorters.page) {
        this.switchTabulatorPage = parseInt(sorters.page)
        this.tabulatorOptions.page = parseInt(sorters.page)
      }

      if (query.perPage) {
        this.tabulatorOptions.paginationSize = parseInt(query.perPage)
      }
      if (query.page && parseInt(query.page) !== 1) {
        this.switchTabulatorPage = parseInt(query.page)
      }

      if (this.isInitiallyMobile) {
        if (query.page && parseInt(query.page) !== 1 && query.perPage) {
          this.temporaryPaging = true
          this.temporaryPage = 1
          this.temporaryPerPage = parseInt(query.page) * parseInt(query.perPage)

          this.originalPage = parseInt(query.page)
          this.originalPerPage = parseInt(query.perPage)

          this.tabulatorOptions.paginationSize = this.temporaryPerPage
          this.switchTabulatorPage = this.temporaryPage
        }
      }
      this.tabulatorOptions.initialSort = this.getInitialSort()
      // let initialFilter = this.getInitialFilter()
      this.tabulatorOptions.initialHeaderFilter = this.getInitialFilter()
      // this.tabulatorOptions.currentHeaderFilter = this.tabulatorOptions.initialHeaderFilter
    },
    getReportFilter () {
      const queryParams = []
      // console.log(this.currentFilter)
      this.currentFilter.forEach((param) => {
        if (Array.isArray(param.value)) {
          if (typeof param.value[0] !== 'undefined' && param.value[0] !== '') {
            queryParams.push(`filter[${param.field}-From]=${param.value[0]}`)
          }
          if (typeof param.value[1] !== 'undefined' && param.value[1] !== '') {
            queryParams.push(`filter[${param.field}-To]=${param.value[1]}`)
          }
        } else {
          queryParams.push(`filter[${param.field}]=${param.value}`)
        }
      })
      return queryParams
    },
    getInitialFilter () {
      const query = this.$router.currentRoute.query
      const filter = []
      // Was very late when I came up with this
      Object.keys(query).forEach(function (key) {
        if (key.startsWith('filter[')) {
          if (key.endsWith('-From]')) {
            const existingFilter = filter.filter(filter => filter.field === key.slice(7, -6))
            if (existingFilter.length === 1) {
              existingFilter[0].value[0] = query[key]
            } else {
              filter.push({
                field: key.slice(7, -6),
                value: [query[key], '']
              })
            }
          } else if (key.endsWith('-To]')) {
            const existingFilter = filter.filter(filter => filter.field === key.slice(7, -4))
            if (existingFilter.length === 1) {
              existingFilter[0].value[1] = query[key]
            } else {
              filter.push({
                field: key.slice(7, -4),
                value: ['', query[key]]
              })
            }
          } else {
            filter.push({
              field: key.slice(7, -1),
              value: query[key]
            })
          }
        }
      })
      return filter
    },
    getInitialSort () {
      const query = router.currentRoute.query
      const sort = []
      const sortBy = query.sort_by
      const sortDesc = query.sort_desc
      if (sortBy && sortDesc) {
        sort.push({
          column: sortBy,
          dir: sortDesc
        })
      } else {
        const sorters = JSON.parse(localStorage.getItem(this.tabSortersStorageName))
        if (sorters && sorters.sorters && sorters.sorters.length > 0) {
          sort.push({
            column: sorters.sorters[0].field,
            dir: sorters.sorters[0].dir
          })
        }
      }
      return sort
    },
    ajaxResponse (url, params, response) {
      this.pageChanged = true
      this.pageLoader = false
      let totalElements = response.additionalInformation
      if (typeof totalElements === 'object') {
        totalElements = totalElements.totalRows
      }
      if (response.additionalInformation.selection) {
        this.tabulatorRetrievedSelectionData = response.additionalInformation.selection
      }
      const retObj = {
        contentType: 'application/json; charset=utf-8',
        data: response.payload,
        last_page: this.getPageCount(totalElements)
      }
      if (this.switchTabulatorPage !== false) {
        this.$refs.tabulator.$children[1].getInstance().modules.page.page = this.switchTabulatorPage
        this.switchTabulatorPage = false

        if (this.temporaryPaging) {
          this.$refs.tabulator.$children[1].getInstance().modules.page.page = this.originalPage
          this.$refs.tabulator.$children[1].getInstance().modules.page.size = this.originalPerPage
          this.temporaryPaging = false
        }
      }
      const totalElement = document.getElementsByClassName('total-rows-number')
      if (totalElement.length && totalElements) {
        totalElement[0].innerHTML = this.formatLongInteger(totalElements)
      } else {
        totalElement[0].innerHTML = '-'
      }
      if ('additionalInformation' in response) {
        if (typeof response.additionalInformation === 'object') {
          this.tabulatorNumberOfRows = response.additionalInformation.totalRows
        } else {
          this.tabulatorNumberOfRows = response.additionalInformation
        }
      }
      return retObj
    },
    ajaxRequesting (url) {
      if (!accessTokenValid()) {
        Vue.http.headers.common[this.REFRESH_TOKEN] = 'IN_PROGRESS'
        const refreshTokenUrl = Vue.$apiConfig.loginRefresh
        Vue.http.headers.common[this.AUTHORIZATION] = 'Bearer ' + getRefreshToken()
        Vue.http.get(refreshTokenUrl)
          .then(response => {
            this.logConsole('tabulator refresh')
            setAccessToken(response.data.payload.accessToken)
            Vue.http.headers.common[this.AUTHORIZATION] = 'Bearer ' + response.data.payload.accessToken
            Vue.http.headers.common[this.REFRESH_TOKEN] = 'DONE'
          }, error => {
            this.logConsole(error)
            Vue.http.headers.common[this.REFRESH_TOKEN] = 'DONE'
          })
      } else {
        if (url === '') {
          return false
        }

        return true
      }
    },
    getPageCount (totalRows) {
      if (!totalRows) {
        totalRows = 0
      }
      const addition = (totalRows % this.tabulatorInstance.modules.page.size) > 0 ? 1 : 0
      return Math.floor(totalRows / this.tabulatorInstance.modules.page.size) + addition
    },
    saveSorters (params) {
      const data = {
        sorters: params.sorters,
        page: params.page,
        perPage: params.perPage
      }

      localStorage.setItem(this.tabSortersStorageName, JSON.stringify(data))
    },
    saveFilters (filters) {
      const formattedFilters = []

      filters.forEach((filter) => {
        formattedFilters.push({
          field: filter.field,
          value: filter.value,
          type: filter.type
        })
      })
      localStorage.setItem(this.tabFiltersStorageName, JSON.stringify(formattedFilters))
    },
    formatUrl (url, config, params, refName) {
      if (typeof refName === 'undefined') {
        refName = 'tabulator'
      }
      if (this.justLoaded) {
        this.setFilterHeader(refName)
        params.filters = this.getFiltersFromStorage()
        const sorters = JSON.parse(localStorage.getItem(this.tabSortersStorageName))

        if (sorters && sorters.page && params.page === 1) {
          params.page = sorters.page
        }
        this.justLoaded = false
      } else {
        this.saveFilters(params.filters)
        this.saveSorters(params)
      }
      const filtersSummary = []
      let queryString = `perPage=${params.perPage}`
      if (params.page) {
        queryString += `&page=${params.page}`
      }
      if (Array.isArray(params.sorters) && params.sorters.length > 0) {
        queryString += `&sort_by=${params.sorters[0].field}&sort_desc=${params.sorters[0].dir}`
      }
      for (var key in params) {
        if (!['sorters', 'filters', 'page', 'perPage'].includes(key)) {
          queryString += `&${key}=${params[key]}`
        }
      }

      if (Array.isArray(params.filters) && params.filters.length > 0) {
        const toBeRemoved = []
        const toBeAdded = []
        var cellDefinition = {
          value: '',
          getValue: function () {
            return this.value
          }
        }

        params.filters.forEach((filter) => {
          const fieldDef = this.tabulatorOptions.columns.find(x => x.field === filter.field)
          var fieldClone = Object.assign({}, fieldDef)
          if (fieldDef && fieldDef.headerFilterParams && fieldDef.headerFilterParams.isRange) {
            const copy = JSON.parse(JSON.stringify(filter))
            if (typeof filter.value[0] !== 'undefined' && filter.value[0] !== '') {
              toBeAdded.push({
                field: copy.field + '-from',
                type: copy.type,
                value: copy.value[0]
              })
              fieldClone.value = copy.value[0] + ' - '
            }
            if (typeof filter.value[1] !== 'undefined' && filter.value[1] !== '') {
              toBeAdded.push({
                field: copy.field + '-to',
                type: copy.type,
                value: copy.value[1]
              })
              if (fieldClone.value === undefined) {
                fieldClone.value = copy.value[1]
              } else {
                fieldClone.value += copy.value[1]
              }
            }
            fieldClone.filterType = copy.type
            toBeRemoved.push(filter)
          } else {
            cellDefinition.value = filter.value
            fieldClone.value = filter.value
            if (fieldDef && fieldDef.formatter && fieldDef.formatter !== 'rowSelection') {
              fieldClone.value = fieldDef.formatter(cellDefinition) ? fieldDef.formatter(cellDefinition).replace(/<\/?[^>]+>/ig, ' ') : filter.value
            }
            if (typeof filter.value === 'undefined') {
              toBeRemoved.push(filter)
            }
          }

          if ((filter.value || filter.value === 0) && fieldDef && fieldDef.formatter !== 'rowSelection') {
            filtersSummary.push({
              value: fieldClone.value,
              field: fieldClone.field,
              title: fieldClone.title
            })
          }
        })

        params.filters = params.filters.filter((el) => !toBeRemoved.includes(el))
        params.filters.push(...toBeAdded)
        params.filters.forEach((filter) => {
          queryString += `&filter[${filter.field}]=${filter.value}`
        })
      }
      EventBus.$emit('filter-' + refName, {
        params: filtersSummary
      })
      window.history.replaceState({}, null, router.currentRoute.path + '?' + queryString)
      return url.includes('?') ? url + '&' + queryString : url + '?' + queryString
    },
    filterSummary (tabulatorRefName) {
      if (typeof this.$refs[tabulatorRefName] === 'undefined') {
        return
      }
      var filtersSummary = []
      var cellDefinition = {
        value: '',
        getValue: function () {
          return this.value
        }
      }
      var instance = this.$refs[tabulatorRefName].$children[1].getInstance()
      var activeFilters = instance.getFilters(true)
      activeFilters.forEach((filter) => {
        const fieldDef = this.$refs[tabulatorRefName].$children[1].getInstance().getColumnDefinitions().find(x => x.field === filter.field)
        var fieldClone = Object.assign({}, fieldDef)
        if (fieldDef && fieldDef.headerFilterParams && fieldDef.headerFilterParams.isRange) {
          const copy = JSON.parse(JSON.stringify(filter))
          if (typeof filter.value[0] !== 'undefined' || filter.value[0] !== '') {
            fieldClone.value = copy.value[0] + ' - '
          }
          if (typeof filter.value[1] !== 'undefined' || filter.value[1] !== '') {
            fieldClone.value += copy.value[1]
          }
        } else {
          cellDefinition.value = filter.value
          fieldClone.value = filter.value
          if (fieldDef.formatter && fieldDef.formatter !== 'rowSelection') {
            fieldClone.value = fieldDef.formatter(cellDefinition) ? fieldDef.formatter(cellDefinition).replace(/<\/?[^>]+>/ig, ' ') : filter.value
          }
        }
        if (fieldDef.formatter !== 'rowSelection') {
          filtersSummary.push({
            value: fieldClone.value,
            field: fieldClone.field,
            title: fieldClone.title
          })
        }
      })
      EventBus.$emit('filter-' + tabulatorRefName, {
        params: filtersSummary
      })
    },
    vDateRange (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      var instance = new ComponentClass({
        propsData: {
          value: cell.getValue(),
          vuetify_ref: this.$vuetify,
          label: label,
          type: 'DateRangePicker',
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    vBoolSelect (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      var instance = new ComponentClass({
        propsData: {
          value: cell.getValue(),
          vuetify_ref: this.$vuetify,
          label: label,
          type: 'BoolSelect',
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    vTextSelect (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      var instance = new ComponentClass({
        propsData: {
          value: cell.getValue(),
          vuetify_ref: this.$vuetify,
          label: label,
          type: 'TextSelect',
          items: editorParams.values,
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    vMoneyRangeFilter (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      var instance = new ComponentClass({
        propsData: {
          value: cell.getValue(),
          vuetify_ref: this.$vuetify,
          label: label,
          type: 'MoneyRange',
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    vTextFieldFilter (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      var instance = new ComponentClass({
        propsData: {
          value: cell.getValue(),
          vuetify_ref: this.$vuetify,
          label: label,
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    currentInstance () {
      if (this.$refs.tabulator) {
        return this.$refs.tabulator.$children[1].getInstance()
      }
    },
    vYearSelect (cell, onRendered, success, cancel, editorParams) {
      var ComponentClass = Vue.extend(HeaderFilters)
      const label = editorParams.label ? editorParams.label : this.$t('tabulator.headerFilters.default')
      const filter = this.tabulatorOptions.initialHeaderFilter ? this.tabulatorOptions.initialHeaderFilter.filter(filter => filter.field === cell.getField()) : null
      var instance = new ComponentClass({
        propsData: {
          value: filter && filter.length === 1 ? filter[0].value : '',
          vuetify_ref: this.$vuetify,
          label: label,
          type: 'YearSelect',
          changeCallback: success,
          readonly: this.pageLoader,
          cancel: cancel
        }
      })
      onRendered(instance.$forceUpdate)
      instance.$mount()
      this.instancesArray.push(instance)
      return instance.$el
    },
    getSorter (type) {
      if (type === 1) {
        return 'number'
      }

      if (type === 5) {
        return 'number'
      }

      if (type === 4) {
        return 'date'
      }

      if (type === 6) {
        return 'boolean'
      }

      return 'string'
    },
    getFilters (type) {
      if (type === 6) {
        return this.vBoolSelect
      }

      if (type === 4) {
        return this.vDateRange
      }

      if (type === 7) {
        return this.vTextSelect
      }

      return this.vTextFieldFilter
    },
    handleRowClickNavigation (e, link) {
      // checks if the event was triggered by a middle mouse click
      if (e.button === 1) {
        e.preventDefault()
        window.open(link, '_blank')
        return
      }
      this.$router.push(link)
    },
    getFiltersFromStorage () {
      return JSON.parse(localStorage.getItem(this.tabFiltersStorageName))
    },
    setFilterHeader (refName) {
      if (this.$refs[refName]) {
        const filters = this.getFiltersFromStorage()
        if (filters) {
          filters.forEach((filter) => {
            const tabulator = this.$refs[refName].$children[1].getInstance()
            if (typeof tabulator.setHeaderFilterValue === 'function') tabulator.setHeaderFilterValue(filter.field, filter.value)
          })
        }
      }
    }
  },
  watch: {
    pageLoader: function (val) {
      this.instancesArray.forEach(function (instance) {
        instance.$props.readonly = val
      })
    }
  },
  mounted () {
    if (this.$refs.tabulator) {
      this.tabulatorInstance = this.$refs.tabulator.$children[1].getInstance()
    }
  },
  created () {
    EventBus.$on('reloadData', () => {
      this.tabulatorInstance.setData()
    })
    EventBus.$on('tabulatorStopRedraw', () => {
      this.tabulatorInstance.blockRedraw()
    })
    EventBus.$on('selectRow', (selectedRow) => {
      this.tabulatorInstance.selectRow(parseInt(selectedRow.id))
    })
    EventBus.$on('removeFilter', (params) => {
      if (this.$refs[params.targetName]) {
        this.$refs[params.targetName].$children[1].getInstance().setHeaderFilterValue(params.field, '')
      }
    })
    EventBus.$on('removeAllFilters', (params) => {
      if (this.$refs[params.targetName]) {
        this.$refs[params.targetName].$children[1].getInstance().clearHeaderFilter()
      }
    })

    this.setInitialParameters()
  }
}
